import * as React from 'react';
import { Intent, Spinner, Callout } from '@blueprintjs/core';
import { executeQueryPost } from 'app/utils/api';
import { LargeButton } from '../LargeButton';
import { StandardInput } from '../StandardInput';

interface Props {
    code: string;
    recoveryDone: () => void;
};

interface State {
    waitingForAPI: boolean;
    userPassword: string;
    userPasswordVerify: string;
    showConfirmation: boolean;
    errorMessage: string;
}

export class ResetPassword extends React.Component<Props, State> {

    state: State = {
        waitingForAPI: false,
        userPassword: "",
        userPasswordVerify: "",
        showConfirmation: false,
        errorMessage: ""
    }
    
    handleSendRequest = () => {
        this.setState({
            waitingForAPI: true
        });

        const {
            userPassword,
            userPasswordVerify
        } = this.state;

        if (userPassword === "") {
            this.setState({
                errorMessage: "You must enter a new password"
            });

            return;
        }

        if (userPassword !== userPasswordVerify) {
            this.setState({
                errorMessage: "The passwords you entered do not match"
            });

            return;
        }

        const {
            code
        } = this.props;

        executeQueryPost("users/resetpassword", {
            password: userPassword,
            code: code
        }, (response) => {
            // @ts-ignore
            window.location = "https://portal.vleader.net";

            this.setState({
                showConfirmation: true
            });
        })
    }

    handlePasswordChange = (e:any) => {
		if (e && e.target) {
			const newValue = e.target.value;

			this.setState({
				userPassword: newValue
			});
		}
    }
    
    handlePasswordVerifyChange = (e:any) => {
		if (e && e.target) {
			const newValue = e.target.value;

			this.setState({
				userPasswordVerify: newValue
			});
		}
	}

	render() {
        const {
            waitingForAPI,
            userPassword,
            userPasswordVerify,
            errorMessage
        } = this.state;

        if (waitingForAPI) return <Spinner />

        const hasErrorMessage = !(errorMessage === "" || errorMessage === undefined);

		return <span>
            {hasErrorMessage ? <Callout style={{marginBottom: '20px'}} intent={Intent.DANGER}>{errorMessage}</Callout> : undefined}
            <StandardInput 
                autoFocus={true}
                onChange={this.handlePasswordChange}
                type={"password"}
                value={userPassword}
                label={"New Password"} />
            <StandardInput 
                autoFocus={false}
                onChange={this.handlePasswordVerifyChange}
                type={"password"}
                value={userPasswordVerify}
                label={"New Password Again"} />

            <LargeButton text={"Change Password"} rightIcon={"password"} intent={Intent.SUCCESS} onClick={() => {
                this.handleSendRequest();
            }} />
        </span>
	}
}
